module.exports = __webpack_public_path__ + "img/9788959522064.78188a45.jpg";